export const version = '2.15.0';
//# sourceMappingURL=version.js.map